
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exhibitions/[id]",
      function () {
        return require("private-next-pages/exhibitions/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exhibitions/[id]"])
      });
    }
  